/**
 * Created by tong on 2018/1/23.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, message, Modal, Row, Col, InputNumber, Select, Upload, Icon} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import './invoice.css';
import {sKeylist} from '../../service/dictionary/dataitem';
import {
    getProductList5,
    setProductUp1,
    getProductCategory,
    exportFun,
    newPurchaseUnit,
    amountInvoiceDetail
} from '../../service/invoiceManagement';
import {Store, Actions} from './store';
import {objectSerial, config, toImportExcel2, downLoadTemplate} from 'Utils';
import {fetchChannelList} from "../../service/home";

class invoiceApplyStart extends Reflux.Component {
    dmsIcon = {
        fontFamily: 'dmsIcon!important'
    };

    constructor(props) {
        super(props);
        const d = new Date();
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.defaultIndex = '';
        this.defaultOrgId = null;
        this.defaultOrgType = null;
        this.defaultDate = d.format('yyyy-MM-dd');
        this.state = {
            opts: ['开票申请'],
            key: 0,
            visible: false,
            selectedRowKeys: [],
            rowSelection: [],
            rows: [],
            total: 1,
            channel_rank: [],
            channel_type: [],
            buy: [],
            searchObj: {
                name: '',
                category: [],
                active: '',
                // startDate: d.format('yyyy-MM-dd'),
                // endDate: d.format('yyyy-MM-dd'),
                crStartDate: '',
                crEndDate: '',
                orderStartDate: '',
                orderEndDate: '',
                saleType: '',
                channel: '',
                projectName: '',
                remark: '',
                lineRemark: '',
                s: 10,
                p: 1,

            },
            categoryData: [],
            button_limits_end: {},
            loading: true,
            appoint: {	// 指定金额开票
                totalAmount: '',
                salesUnitId: '',
                salesChannelCode: ''
            },
            channelList: []
        };
        this.pageChange = this.pageChange.bind(this);
        this.addChange = this.addChange.bind(this);
        this.importExcel = this.importExcel.bind(this);
        this.specifiedChange = this.specifiedChange.bind(this);
        this.exportChange = this.exportChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    /*选择*/
    onSelectChange = (selectedRowKeys, rowSelection) => {

        var selectitems = this.state.rowSelection;

        var items = [];

        rowSelection.forEach((key, i) => {

            var flag = true;

            selectitems.forEach((k, z) => {
                if (k.deliveryId == rowSelection[i].deliveryId && k.orderNumber == rowSelection[i].orderNumber && k.salesChannelCode == rowSelection[i].salesChannelCode && k.salesUnitId == rowSelection[i].salesUnitId && k.lineRemark == rowSelection[i].lineRemark) {
                    flag = false;
                    return;
                }
            })
            if (flag) {
                selectitems.push(rowSelection[i]);
            }
        });

        selectitems.forEach((key, i) => {
            if (selectedRowKeys.indexOf(key.key) >= 0) {
                items.push(selectitems[i]);
            }
        });

        this.setState({selectedRowKeys, rowSelection: items});

    };
    /*筛选*/
    // setFilterParam(name, value) {
    //     this.setState({ searchObj: { ...this.state.searchObj, [name]: value } })
    // };
    setFilterParam(name, value) {
        if (name === 'orderTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    crStartDate: value.from,
                    crEndDate: value.end,
                }
            })
        } else if (name === 'orderTime2') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    orderStartDate: value.from,
                    orderEndDate: value.end,
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*提交*/
    addChange(dat, tag) {
        // console.log(dat);
        // console.log(tag);
        // return;
        if (this.state.selectedRowKeys.length === 0 && tag != 'appoint') {
            openNotice('warning', '请选择产品');
            return;
        }
        // debugger
        // console.log(this.state.selectedRowKeys);
        // console.log(this.state.rowSelection)
        var arr = {};
        var deliveryIdList = new Array();
        var salesUnitIdList = new Array();
        var salesChannelCodeList = new Array();
        var orderNumberList = new Array();
        var lineRemarkList = new Array();
        let rows = tag ? dat : this.state.rowSelection;
        rows.forEach(x => {
            deliveryIdList.push(x.deliveryId);
            salesUnitIdList.push(x.salesUnitId);
            salesChannelCodeList.push(x.salesChannelCode);
            orderNumberList.push(x.orderNumber);
            lineRemarkList.push(x.lineRemark);
        });
        let params = {};
        params.deliveryIdList = deliveryIdList;
        params.salesUnitIdList = salesUnitIdList;
        params.salesChannelCodeList = salesChannelCodeList;
        params.orderNumberList = orderNumberList;
        params.lineRemarkList = lineRemarkList;
        // console.log(params);
        // debugger
        let self = this;
        // setProductUp1(params).then(function (result) {
        // 	if (result && result.code == 200) {
        // 		// openNotice('success', '添加成功', '');
        // 		// self.initData();
        // 		window.localStorage.setItem('paramsToApply', JSON.stringify(params));
        // 		self.goView(`/invoiceManagement/invoiceApply`);
        // 	} else {
        // 		openNotice('error', '查询失败', (result && result.message) ? result.message : '');
        // 	}
        // });
        Object.assign(params);
        window.localStorage.setItem('paramsToApply', JSON.stringify(params));
        self.goView(`/invoiceManagement/invoiceApply`);

    };

    /*Excel导入开票*/
    importExcel(res) {
        console.log(res);
        const self = this;
        /* 直接开票 */

        const selectedRows = res.lineSyncList;
        const type = res.specialBillingFlag || 'N';
        if (!selectedRows.length) {
            openNotice('warning', '请选择产品');
            return;
        }
        let unitId = selectedRows[0].salesUnitId,
            unitChannelCode = selectedRows[0].salesChannelCode,
            unitTaxCode = selectedRows[0].taxCode,
            list = [], list2 = [];
        for (var i = 0; i < selectedRows.length; i++) {
            if (selectedRows[i].salesUnitId != unitId) {
                openNotice('warning', '请导入相同的购货单位');
                return;
            }
            if (selectedRows[i].salesChannelCode != unitChannelCode) {
                openNotice('warning', '请导入相同的渠道');
                return;
            }
            if (selectedRows[i].taxCode != unitTaxCode) {
                openNotice('warning', '请导入相同的税码');
                return;
            }
            list.push({
                // deliveryId: selectedRows[i].deliveryId,
                // orderNumber: selectedRows[i].orderNumber,
                // itemNum: selectedRows[i].itemNum
                lineId: selectedRows[i].lineId
            });
            list2.push({
                qty: selectedRows[i].qty,
                adjustDesc: selectedRows[i].adjustDesc,
                adjustUnit: selectedRows[i].adjustUnit,
                newDescCategories: selectedRows[i].newDescCategories
            })
        }

        // console.log(list);
        /*let list = selectedRows.map(x => {
            return {
                deliveryId: x.deliveryId,
                orderNumber: x.orderNumber,
                itemNum: x.itemNum
            }
        });*/
        let url = "";
        if (type == "Y") {
            url = 'invoiceManagement/specialInvoice';
        } else {
            url = 'invoiceManagement/normalInvoice';
        }
        this.goView({
            pathname: url,
            state: {
                type: 'direct',
                list,
                list2
            }
        });

    };

    /*指定金额开票*/
    specifiedChange = () => {
        let appoint = this.state.appoint;
        Object.keys(appoint).map(x => {
            appoint[x] = '';
        });
        // appoint.salesUnitId = this.state.buyValue;
        this.setState({
            visible: true,
            appoint
        });
    };
    handleOk = (e) => {
        // console.log(e);
        let obj = this.state.appoint;
        if (!obj.totalAmount) {
            message.warning('请输入金额');
            return
        }
        if (!obj.salesUnitId) {
            message.warning('请选择购货单位');
            // obj.salesUnitId = this.state.buyValue;
            return
        }
        if (!obj.salesChannelCode) {
            message.warning('请选择渠道类型');
            return
        }
        this.setState({
            visible: false,
            loading: true
        });
        // obj.salesUnitId = this.state.appoint.salesUnitId.toString();
        // debugger
        // console.log(obj);
        amountInvoiceDetail({...obj}).then(res => {
            if (res && res.data) {
                this.setState({
                    // rows: res.data,
                    // total: res.total,
                    loading: false
                });
                this.addChange(res.data, 'appoint');
            } else {
                openNotice('error', '开票失败,指定购货单位没有可开票的记录');
                //后台让写的
                this.setState({loading: false})
            }
        });
    };
    handleCancel = (e) => {
        // console.log(e);
        this.setState({
            visible: false,
        });
    };

    invoiceAppointFn(type, tar) {
        let _val = ''
        // console.log(type);
        // console.log(tar);
        switch (type) {
            case 'totalAmount':
                // console.log(tar.target.value);
                _val = tar;
                break;
            case 'salesUnitId':
            // 	_val = tar.toString();
            // break;
            case 'salesChannelCode':
                _val = tar.key;
                break;
        }
        this.setState({
            appoint: {
                ...this.state.appoint,
                [type]: _val
            }
        }, () => {
            // console.log(this.state.appoint);
        });
    }

    /*导出*/
    exportChange() {
        downLoadTemplate(6);
        /*const {searchObj, rows, total, rowSelection} = this.state;
        if (!rowSelection.length) {
            openNotice('warning', '请选择订单');
            return;
        }
        if(!rows.length && !total){
            message.warning('当前没有数据可以导出。请查询后再做操作。');
        } else {
            let _arr = rowSelection.map(x => {
                console.log(x);
                return {
                    lineId: x.lineId
                };
            });
            console.log(_arr);
            Modal.confirm({
                title: '操作提示',
                content: '确定导出当前条件的数据吗?',
                onOk() {
                    // window.location.href = `${exportFun}?${objectSerial({...searchObj, s: total, endDate: searchObj.endDate+' 23:59:59'})}&exPortType=0&exPortIds=`
                    // let xxx = `${exportFun}?${objectSerial({...searchObj, s: total, endDate: searchObj.endDate+' 23:59:59'})}&exPortType=0&exPortIds=`
                    window.location.href = `${config}/api/v1/dms/tzOrderSync/exportInvoiceInfo?lineIds=${_arr.join('lineIds=')}`;
                    console.log(config);
                },
                onCancel() {
                },
            });
        }*/
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选重置*/
    advanceReset() {
        let self = this;
        self.setState({
            channel_rank: [],
            channel_type: [],
            buy: [],
            searchObj: {
                ...this.state.searchObj,

                itemNum: '',
                itemDesc: '',
                // orderTime: '',
                crStartDate: '',
                crEndDate: '',
                deliveryId: '',
                channel: '',
                orderNumber: '',
                orderStartNumber: '',
                orderEndNumber: '',
                // salesUnitName: '',
                // orderTime2: '',
                orderStartDate: '',
                orderEndDate: '',
                salesUnitId: '',
                lineId: '',
                saleType: '',
                projectName: '',
                remark: '',
                lineRemark: ''
            }
        }, function () {
            self.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        let self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };

    /* 翻页 刷新 */
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    };

    /*获取列表数据*/
    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        let channelList = self.state.channelList;
        searchObj.categoryId = searchObj.category.length > 0 ? searchObj.category[searchObj.category.length - 1] : '';
        self.setState({
            loading: true
        })
        getProductList5(searchObj).then(function (result) {
            if (result && result.code == 200) {
                result.data.map((item, index) => {
                    item.uniqueKey = index;
                    item.key = item.deliveryId + item.orderNumber + item.salesChannelCode + item.salesUnitId + item.orderCategoryCode + item.lineRemark;
                    channelList.map(itm => {
                        if (itm.code == item.salesChannelCode) {
                            item.salesChannelName = itm.name;
                        }
                    });
                })
                self.setState({
                    'rows': result.data || [],
                    'total': result.total,
                    'loading': false
                });
            } else {
                openNotice('error', '数据获取失败', '');
            }
        });

        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.buyerStatus || 0
            });
        }

        getProductCategory().then(function (categoryResult) {
            /* 产品分类 */
            if (!categoryResult || categoryResult.code != 200) {
                openNotice('error', '产品分类数据获取失败，请重试', '');
                return;
            }
            self.setState({
                categoryData: categoryResult.data || []
            });
        });
    };

    /*离开当前路由时，更新store*/
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    };

    componentWillMount() {
        let self = this;
    }

    componentDidMount() {
        fetchChannelList().then(result => {
            if (result && result.code == 200 && result.status == true) {
                this.setState({channelList: result.data}, () => {
                    //this.initData();
                    this.setState({
                        loading: false
                    })
                })
            }
        });
        sKeylist({sKey: 'INVOICE_ORDER_TYPE'}).then(res => { //发运类型
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.sKey
                    })
                });
                this.setState({channel_rank: arr})
            }
        });
        /* 渠道选项 */
        let _channel = JSON.parse(window.sessionStorage.getItem('channel_list')), arr = [];
        //_channel.shift();
        _channel.map(x => {
            arr.push({
                text: x.name,
                value: x.code
            })
        });
        this.setState({channel_type: arr});

        var channelData = window.sessionStorage.getItem('cur_channelId') || '{}';
        newPurchaseUnit(channelData).then(res => { // 购货单位
            if (res.status) {
                var arr = new Array();
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                });
                var appoint = {...this.state.appoint};
                appoint.salesUnitId = res.data[0].id.toString();
                this.setState({
                    buy: arr,
                    buyText: res.data[0].name.toString(),
                    buyValue: res.data[0].id.toString(),
                    appoint: {
                        ...this.state.appoint,
                        salesUnitId: res.data[0].id.toString(),
                    }
                })
            }
        });

        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    render() {
        const {
            opts,
            key,
            rows,
            total,
            searchObj,
            selectedRowKeys,
            rowSelection,
            channel_rank,
            channel_type,
            button_limits_end,
            buy,
            loading,
            appoint
        } = this.state;
        const advanceProps = {
            fileds: [

                {
                    name: 'orderTime',//startCreatedDate, endCreatedDate
                    label: '日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.crStartDate || '',
                        end: searchObj.crEndDate || ''
                    },
                },
                {
                    name: 'deliveryId',
                    label: '出库单号',
                    text: '输入出库单号',
                    type: 'default',
                    defaultValue: searchObj.deliveryId
                },
                {
                    name: 'channel',
                    label: '渠道',
                    text: '选择状态',
                    options: channel_type,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.channel || ''
                },
                {
                    name: 'orderStartNumber',
                    label: '订单编号',
                    text: '输入订单编号',
                    type: 'default',
                    defaultValue: searchObj.orderStartNumber
                },
                {
                    name: 'orderEndNumber',
                    label: '至',
                    text: '输入订单编号',
                    type: 'default',
                    width: 50,
                    defaultValue: searchObj.orderEndNumber
                },
                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '输入购货单位',
                    type: 'select',
                    options: buy,
                    require: true,
                    showSearch: true,
                    defaultValue: searchObj.salesUnitName
                },
                {
                    name: 'saleType',
                    label: '发运类型',
                    text: '选择发运类型',
                    options: channel_rank,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.saleType || ''
                },
                {
                    name: 'projectName',
                    label: '合同/订单名称',
                    text: '输入合同/订单名称',
                    type: 'default',
                    defaultValue: searchObj.projectName
                },
                {
                    name: 'remark',
                    label: '头备注',
                    text: '输入头备注',
                    type: 'default',
                    defaultValue: searchObj.remark
                },
                {
                    name: 'lineRemark',
                    label: '行备注',
                    text: '输入行备注',
                    type: 'default',
                    defaultValue: searchObj.lineRemark
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'key',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '可用数量',
                    dataIndex: 'qty'
                },
                {
                    title: '发运类型',
                    dataIndex: 'orderCategoryName'
                },
                {
                    title: '购货单位',
                    dataIndex: 'salesUnitName'
                },
                {
                    title: '渠道',
                    dataIndex: 'salesChannelName'
                },
                {
                    title: '金额',
                    dataIndex: 'totalAmount'
                },
                {
                    title: '出库单号',
                    dataIndex: 'deliveryId'
                },
                {
                    title: '订单编号',
                    dataIndex: 'orderNumber'
                },
                {
                    title: '合同/订单名称',
                    dataIndex: 'projectName'
                },
                {
                    title: '行备注',
                    dataIndex: 'lineRemark'
                },
                {
                    title: '出库日期',
                    dataIndex: 'crDate',
                    render: text => text ? new Date(text).format('yyyy-MM-dd') : '----'
                },
                /*{
                    title: '渠道',
                    dataIndex: 'salesChannelCode',
                },*/
            ],
            rows,
            rowSelection: {
                rowSelection,
                selectedRowKeys,
                onChange: this.onSelectChange
            }
        };
        const iconLayout = {
            fontSize: '32px'
        };
        let buyUnitList = []	// 购货单位
            , salesChannel = [] 	// 渠道类型
            , channelList = JSON.parse(window.sessionStorage.getItem('channel_list'))
        ;
        // console.log(buy);
        channelList.shift();	// 去掉“所有渠道”
        buyUnitList = buy.map(x => {
            return <Select.Option key={x.value + ''} value={x.value + ''}>{x.text}</Select.Option>
        });
        salesChannel = channelList.map(x => {
            return <Select.Option key={x.code + ''} value={x.code + ''}>{x.name}</Select.Option>
        });
        let uploadParam = toImportExcel2(
            6,
            (result) => {
                this.importExcel(result)
            }
        );
        return <div>
            <DmsTab options={opts} defaultKey={key}>
                <Button key="back" onClick={this.goView.bind(this, `/invoiceManagement`)}>返回</Button>
            </DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    {/*<a className="dms-table-a" onClick={this.goView.bind(this, `/invoiceManagement/invoiceStaging`)}>
						<i className="anticon anticon-exception" style={iconLayout}></i>&nbsp;&nbsp;&nbsp;
						<span className="stagingCount">20</span>
					</a>*/}
                    {button_limits_end.invoiceApplyStart_list_01 &&
                        <Button style={{position: 'absolute', bottom: 8, right: 365}}
                                onClick={this.addChange}>提交</Button>}
                    {
                        button_limits_end.invoiceApplyStart_list_02
                        &&
                        <Upload {...uploadParam} style={{position: 'absolute', bottom: 8, right: 0}}>
                            <Button>
                                Excel导入开票
                            </Button>
                        </Upload>
                    }
                    {button_limits_end.invoiceApplyStart_list_03 &&
                        <Button style={{position: 'absolute', bottom: 8, right: 243}}
                                onClick={this.specifiedChange}>指定金额开票</Button>}
                    {button_limits_end.invoiceApplyStart_list_04 &&
                        <Button style={{position: 'absolute', bottom: 8, right: 127}} icon="download"
                                onClick={this.exportChange}>下载模板</Button>}
                </div>
                <TableView {...tableViewProps}/>
            </div>
            <div>
                <Modal
                    title="指定金额开票"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    <div>
                        <section className="invoiceAppoint">
                            <Row>
                                <Col>
                                    <label className="ant-form-item-required">请输入金额：</label>
                                    <InputNumber style={{width: 320}} min={1} value={appoint.totalAmount}
                                                 onChange={this.invoiceAppointFn.bind(this, 'totalAmount')}/>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <label className="ant-form-item-required">请选择购货单位：</label>
                                    {/*<Input style={{width:320}} onChange={this.invoiceAppointFn.bind(this, 'unit')}/>*/}
                                    <Select
                                        labelInValue
                                        style={{width: 320}}
                                        value={{key: appoint.salesUnitId /*? appoint.salesUnitId : this.state.buyValue*/}}
                                        // defaultValue={{key:this.state.buyValue,label:this.state.buyText}}
                                        onChange={this.invoiceAppointFn.bind(this, 'salesUnitId')}
                                    >{buyUnitList}</Select>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <label className="ant-form-item-required">请选择渠道类型：</label>
                                    {/*<Input style={{width:320}} onChange={this.invoiceAppointFn.bind(this, 'salesChannelCode')}/>*/}
                                    <Select
                                        labelInValue
                                        style={{width: 320}}
                                        value={{key: appoint.salesChannelCode}}
                                        onChange={this.invoiceAppointFn.bind(this, 'salesChannelCode')}
                                    >{salesChannel}</Select>
                                </Col>
                            </Row>
                        </section>
                        <p style={{
                            paddingTop: '10px',
                            fontSize: '12px'
                        }}>注：输入指定金额后，系统将自动根据指定金额进行开票</p>
                    </div>
                </Modal>
            </div>
        </div>
    }
}

export default withRouter(invoiceApplyStart);


// WEBPACK FOOTER //
// ./src/routes/invoiceManagement/invoiceApplyStart.js